import type { GlEntity } from "../../domain/entities/GlEntity";
import type { GlManagementTreeNodeDTO } from "../models/GlDTOs";

export interface GlTreeNode {
  id: number;
  accountId: string;
  glId: string;
  glName: string;
  accountType: string;
  accountTypeLabel: string;
  status: "active" | "under_review";
  hasChildren: boolean;
  isGroup: boolean;
  bill: boolean;
  invoice: boolean;
  children: GlTreeNode[];
}

export function isBillOrInvoiceChecked(
  value: number | boolean | undefined,
): boolean {
  return value === 1 || value === true;
}

export function mapDtoToGlTreeNode(dto: GlManagementTreeNodeDTO): GlTreeNode {
  return {
    id: dto.id ?? 0,
    accountId: dto.account_id,
    glId: dto.gl_id,
    glName: dto.gl_name,
    accountType: dto.account_type,
    accountTypeLabel: dto.account_type_label,
    status: dto.status,
    hasChildren: dto.has_children,
    isGroup: dto.is_group === true || dto.kind === "group",
    bill: isBillOrInvoiceChecked(dto.bill),
    invoice: isBillOrInvoiceChecked(dto.invoice),
    children: (dto.children ?? []).map(mapDtoToGlTreeNode),
  };
}

export function countGlTreeLeaves(nodes: GlTreeNode[]): number {
  let count = 0;
  const walk = (list: GlTreeNode[]) => {
    for (const node of list) {
      if (!node.hasChildren) {
        count += 1;
      }
      if (node.children.length > 0) {
        walk(node.children);
      }
    }
  };
  walk(nodes);
  return count;
}

export function glTreeNodeToEntity(node: GlTreeNode, parent?: GlTreeNode): GlEntity {
  return {
    id: node.id,
    glId: node.glId,
    glName: node.glName,
    accountId: node.accountId,
    accountType: node.accountType,
    parentId: parent?.accountId ?? null,
    parentName: parent?.glName ?? null,
    isActive: true,
    hasChildren: node.hasChildren,
    isGroup: node.isGroup,
    invoice: node.invoice,
    bill: node.bill,
    isUnderReview: node.status === "under_review",
  };
}
